import { createRefPath } from '../../firestoreData/appData/appRefPaths';
import { grts, responseHandlers, responseReducers } from './reducerHelpers/dispatchProps';

export const _appEventAuthsCollection = '_appEventAuths'

export const rts = {
  handleAmmend_appUserAuthList: 'handleAmmend_appUserAuthList',
  ...grts
}

export const appUsersAuthReducerInitialState = (initState) => {
  return { ...initState }
};

export const appUsersAuthReducer = (state, action) => {

  const { type } = action

  switch (type) {

    case rts.handleAmmend_appUserAuthList:
      return { ...state, appUserAuthList: action.appUserAuthList, appUserAuthTotals: action.totals, appUserAuthUsageData: action.usageData }

    case rts.handleCloseConfirmation:
    case rts.handleFunctionResponse:
    case rts.handleStartUpdate:
    case rts.updateError:
    case rts.updateSuccess:
    case rts.updateSuccessAlt:
      return responseReducers(state, action)

    default:
      return { ...state }
  }
}

export const appUsersAuthHandlers = (dispatch) => {
  return {
    handleAmmend_appUserAuthList: (appUserAuthList, totals, usageData) => { dispatch({ type: rts.handleAmmend_appUserAuthList, dispatch, appUserAuthList, totals, usageData }) },
    ...responseHandlers(dispatch)
  }
} 